/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Attachment
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Attachment
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    size?: string;
}

/**
 * Check if a given object implements the Attachment interface.
 */
export function instanceOfAttachment(value: object): value is Attachment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function AttachmentFromJSON(json: any): Attachment {
    return AttachmentFromJSONTyped(json, false);
}

export function AttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Attachment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'name': json['name'],
        'url': json['url'],
        'type': json['type'],
        'size': json['size'] == null ? undefined : json['size'],
    };
}

export function AttachmentToJSON(json: any): Attachment {
    return AttachmentToJSONTyped(json, false);
}

export function AttachmentToJSONTyped(value?: Attachment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'name': value['name'],
        'url': value['url'],
        'type': value['type'],
        'size': value['size'],
    };
}

